<template>
  <component
    :is="fieldComponent"
    v-model="localModelValue"
    :field="field"
    :error="error"
    :force-enabled="props.forceEnabled"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CustomFieldSingleSelect from '@/components/Fieldable/CustomFieldSingleSelect.vue'
import CustomFieldFreeText from '@/components/Fieldable/CustomFieldFreeText.vue'
import { CustomFieldType } from '@/gql/graphql'
import { useFragment } from '@/gql'
import { FieldableFormCustomFieldFragment } from '@/components/Fieldable/graphql/fragments'
import { FieldableCustomFieldProps } from '@/components/Fieldable/types'

const emits = defineEmits(['update:model-value'])

const props = defineProps<FieldableCustomFieldProps>()

const fieldTyped = computed(() => useFragment(FieldableFormCustomFieldFragment, props.field))

const componentTypeMapping = {
  [CustomFieldType.FreeText]: CustomFieldFreeText,
  [CustomFieldType.SingleSelect]: CustomFieldSingleSelect,
}

const localModelValue = computed({
  get: () => props.modelValue,
  set: (value) => emits('update:model-value', value),
})

const fieldComponent = computed(() => componentTypeMapping[fieldTyped.value.fieldType])
</script>
